import axios from "axios";
import { toast } from "react-toastify";
const BASE_URL = "https://api.bookinclass.co.uk/api/";
//const BASE_URL = "http://185.151.29.175:3000/api/";
//const BASE_URL = "http://localhost:4060/api/";
const notFoundPage = "https://admin.bookinclass.co.uk/404";

export const postFormDataNoToken = async (url = "", data = {}) => {
  try {
    const formData = new FormData();

    for (let key in data) {
      formData.append(key, data[key]);
    }
    const response = await axios.post(BASE_URL +  url, formData);

    return response.data;
  } catch (error) {
    toast.error(error.message);
    return null;
  }
};
export const postFormData = async (url = "", data = {}) => {
  try {
    const token = await localStorage.getItem("token");

    const formData = new FormData();

    for (let key in data) {
      formData.append(key, data[key]);
    }
    const response = await axios.post(BASE_URL + url, formData, {
      headers: { token },
    });
    
    // Handle 401 unauthorized
    if(response.data.code == 401){
      localStorage.removeItem("token");
      toast.error(response.data.message);
      window.location.href = notFoundPage;
      return null;
    }
    
    // Return the response data (including error responses)
    return response.data;
    
  } catch (error) {
    // Handle HTTP errors (4xx, 5xx)
    if (error.response) {
      // The server responded with an error status
      const errorData = error.response.data;
      toast.error(errorData?.message || errorData?.msg || 'Server error occurred');
      return errorData; // Return the error data so frontend can handle it
    } else if (error.request) {
      // The request was made but no response was received
      toast.error('No response from server. Please check your connection.');
      return { code: 0, message: 'No response from server' };
    } else {
      // Something happened in setting up the request
      toast.error(error.message || 'Request failed');
      return { code: 0, message: error.message || 'Request failed' };
    }
  }
};
export const patchFormData = async (url = "", data = {}) => {
  try {
    const token = await localStorage.getItem("token");

    const formData = new FormData();

    for (let key in data) {
      formData.append(key, data[key]);
    }
    const response = await axios.patch(BASE_URL + url, formData, {
      headers: { token },
    });

    if(response.data.code == 401){
      localStorage.removeItem("token");
      toast.error(response.data.message);
      window.location.href = notFoundPage;
      return null;
    }else{
      return response.data;
    }
  } catch (error) {
    toast.error(error.message);
    return null;
  }
};
export const postRawData = async (url = "", data = {}) => {
  try {
    const token = await localStorage.getItem("token");

    const response = await axios.post(BASE_URL + url, data, {
      headers: {
        token,
      },
    });

    if(response.data.code == 401){
      localStorage.removeItem("token");
      toast.error(response.data.message);
      window.location.href = notFoundPage;
      return null;
    }else{
      return response.data;
    }
  } catch (error) {
    toast.error(error.message);
    return null;
  }
};

export const getDataNoToken = async (url = "", data = {}) => {
  try {
    const response = await axios.get(BASE_URL + url, {
      params: data,
    });

    return response.data;
  } catch (error) {
    return null;
  }
};

export const getDataforUrl = async (url = "", data = "") => {
  const token = await localStorage.getItem("token");

  try {
    const response = await axios.get(BASE_URL + url + `/${data}`, {
      headers: {
        token,
      },
    });

    if(response.data.code == 401){
      localStorage.removeItem("token");
      toast.error(response.data.message);
      window.location.href = notFoundPage;
      return null;
    }else{
      return response.data;
    }
  } catch (error) {
    return null;
  }
};
export const getDataforUrlWithParams = async (url = "", data = {}) => {
  const token = await localStorage.getItem("token");

  try {
    const response = await axios.get(BASE_URL + url + `/${data?.id}`, {
      params: data.params,
      headers: {
        token,
      },
    });

    if(response.data.code == 401){
      localStorage.removeItem("token");
      toast.error(response.data.message);
      window.location.href = notFoundPage;
      return null;
    }else{
      return response.data;
    }
  } catch (error) {
    return null;
  }
};

export const getData = async (url = "", data = {}) => {
  try {
    const token = await localStorage.getItem("token");

    const response = await axios.get(BASE_URL + url, {
      params: data,
      headers: {
        token,
      },
    });

    if(response.data.code == 401){
      localStorage.removeItem("token");
      toast.error(response.data.message);
      window.location.href = notFoundPage;
      return null;
    }else{
      return response.data;
    }
  } catch (error) {
    return null;
  }
};

export const getDataStringify = async (url = "", data = {}) => {
  try {
    const token = await localStorage.getItem("token");

    const response = await axios.get(BASE_URL + url, {
      params: data,

      headers: {
        token,
      },
    });

    if(response.data.code == 401){
      localStorage.removeItem("token");
      toast.error(response.data.message);
      window.location.href = notFoundPage;
      return null;
    }else{
      return response.data;
    }
  } catch (error) {
    return null;
  }
};

export const putFormData = async (url = "", data = {}) => {
  try {
    const token = await localStorage.getItem("token");
    const formData = new FormData();

    for (let key in data) {
      formData.append(key, data[key]);
    }
    const response = await axios.put(BASE_URL + url, formData, {
      headers: {
        token,
      },
    });

    if(response.data.code == 401){
      localStorage.removeItem("token");
      toast.error(response.data.message);
      window.location.href = notFoundPage;
      return null;
    }else{
      return response.data;
    }
  } catch (error) {
    return null;
  }
};

export const deleteData = async (url = "", data = {}) => {
  try {
    const token = await localStorage.getItem("token");
    const formData = new FormData();

    for (let key in data) {
      formData.append(key, data[key]);
    }
    const response = await axios.delete(BASE_URL + url, {
      headers: {
        token: token,
      },
      data: formData,
    });

    if(response.data.code == 401){
      localStorage.removeItem("token");
      toast.error(response.data.message);
      window.location.href = notFoundPage;
      return null;
    }else{
      return response.data;
    }
  } catch (error) {
    return null;
  }
};

export const createExportRequest = async (company_id, type) => {
  return await postFormData('admin/createExportRequest', { company_id, type });
};

export const getCompanyExportRequestStatus = async (company_id, type) => {
  try {
    const token = await localStorage.getItem("token");
    const response = await axios.get(BASE_URL + `admin/getCompanyExportRequestStatus?company_id=${company_id}&type=${type}`, {
      headers: { token },
    });

    if(response.data.code == 401){
      localStorage.removeItem("token");
      toast.error(response.data.message);
      window.location.href = notFoundPage;
      return null;
    }else{
      return response.data;
    }
  } catch (error) {
    toast.error(error.message);
    return null;
  }
};

export const logExportAction = async (type, records_processed, file_type = 'csv', company_id) => {
  return await postFormData('admin/logExportAction', { type, records_processed, file_type, company_id });
};

export const getImportExportLogs = async (company_id = null) => {
  const params = company_id ? `?company_id=${company_id}` : '';
  return await getData(`admin/getImportExportLogs${params}`);
};

export const deleteURLData = async (url = "", data = "") => {
  try {
    const token = await localStorage.getItem("token");

    const response = await axios.delete(BASE_URL + url + `/${data}`, {
      headers: {
        token: token,
      },
    });

    if(response.data.code == 401){
      localStorage.removeItem("token");
      toast.error(response.data.message);
      window.location.href = notFoundPage;
      return null;
    }else{
      return response.data;
    }
  } catch (error) {
    return null;
  }
};
